var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExpandir(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.159,
    height: 21.029,
    viewBox: "0 0 21.159 21.029",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(-4.781 -4.851)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_21",
    "data-name": "Caminho 21",
    d: "M16.153,14.893,6.9,5.645A.937.937,0,0,0,5.575,6.966l8.489,8.489L5.818,23.7a.937.937,0,0,0,0,1.321h0a.937.937,0,0,0,1.331,0l9-9a.8.8,0,0,0,0-1.124Z",
    fill: "#000000",
    stroke: "#000000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22",
    "data-name": "Caminho 22",
    d: "M25.733,14.893,16.476,5.645a.937.937,0,0,0-1.321,1.321l8.489,8.489L15.4,23.7a.937.937,0,0,0,0,1.321h0a.937.937,0,0,0,1.321,0l9.014-9a.8.8,0,0,0,0-1.124Z",
    transform: "translate(-0.604 0)",
    fill: "#000000",
    stroke: "#000000",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandir);
export default __webpack_public_path__ + "static/media/expandir.c388311cbb155b6cf41cf0889d6d566b.svg";
export { ForwardRef as ReactComponent };